<template>
    <template v-if="product.initialized">
        <template v-if="!!stock && stock.stock_status">
            <button @click="addToCard" class="btn custom-btn custom-btn--primary single-product__price-box__button">افزودن به سبد خرید</button>
        </template>
        <button v-else class="btn custom-btn custom-btn--dark single-product__price-box__button" disabled>ناموجود</button>
    </template>
    <div v-else class="loading" style="height: 40px;"></div>
</template>

<script>
import {ProductMixin} from "../product/ProductMixin";

export default {
    name: "AddToCart",
    mixins: [ProductMixin],
    methods: {
        addToCard() {
            const config = {
                headers: { Authorization: `Bearer ${this.token()}` }
            };
            this.axios.post(this.route('api.cart.add', [this.stock.id]), {}, config).then(response => {
                this.$swal({
                    text: `${this.product.title} به سبد خرید شما اضافه شد!`,
                    icon: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                });
                this.$store.commit('cart/init', response.data);
            }).catch(error => {
                //@todo handle error
            });
        }
    }
}
</script>

<style scoped>

</style>
